import Model, { attr, belongsTo } from '@ember-data/model';

export default class KeypadEntryModel extends Model
{
	@attr('date') time;
	@attr('number') bib;
	@attr('string') deviceName;

	@belongsTo('device',{inverse: null, async: true}) DeviceId;
}
